import React, { createContext, useContext, useCallback } from 'react';
import { useRealtime } from './RealtimeContext';

const ClaimsContext = createContext(null);

export function ClaimsProvider({ children }) {
  const realtime = useRealtime();

  // Delegate to RealtimeContext — claims are now Supabase-backed
  const claims = realtime?.claims ?? [];

  const addClaim = useCallback(async (claimData) => {
    const result = await realtime?.addClaim(claimData);
    return result?.data || null;
  }, [realtime]);

  const deleteClaim = useCallback(async (claimId) => {
    await realtime?.deleteClaim(claimId);
  }, [realtime]);

  return (
    <ClaimsContext.Provider value={{ claims, addClaim, deleteClaim }}>
      {children}
    </ClaimsContext.Provider>
  );
}

export function useClaims() {
  const ctx = useContext(ClaimsContext);
  if (!ctx) throw new Error('useClaims must be used within ClaimsProvider');
  return ctx;
}
